import React, { useState, useEffect } from "react";
import { Box, Container, makeStyles, Typography } from "@material-ui/core";
import Page from "src/components/Page";
import Form from "./Form";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import { apiEndpoints, apiGetByIdRequest } from "src/utils/api/api";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import KmPageTitle from "src/components/layout/KmPageTitle"

const articleStatus = {
  draft: 'Wersja robocza',
  published: 'Opublikowany',
  archived: 'Zarchiwizowany'
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  title: {
    marginLeft: theme.spacing(3),
  },
}));

const NewsAdminPreviewForm = ({
  enableGlobalLoader,
  disableGlobalLoader,
  setLogoutUser,
  ...rest
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { entryId } = useParams();
  const [news, setNews] = useState(null);
  const editMode = rest.kmaction === "edit";

  let pageTitle = news ? news.title : "Artykuł";

  useEffect(() => {
    enableGlobalLoader();
    apiGetByIdRequest(apiEndpoints.getNewsPreviewDetails.path, entryId, true)
      .then((data) => {
        disableGlobalLoader();
        setNews(data);
      })
      .catch((error) => {
        disableGlobalLoader();
        if (error.response && error.response.status === 401) {
          setLogoutUser();
        }
      });
    return () => {};
  }, []);

  return (
    <Page className={classes.root} title={pageTitle}>
      <KmPageTitle>
        Podgląd artykułu
      </KmPageTitle>
      {news ? (
        <Typography variant="subtitle2" className={classes.title}>
          Status: {articleStatus[news.status]}
        </Typography>
      ) : (
        <></>
      )}

      <Container maxWidth={false}>
        <Box mt={3}>
          <Form news={news} />
        </Box>
      </Container>
    </Page>
  );
};

const mapDispatchToProps = (dispatch) => ({
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
  setLogoutUser: () => dispatch(actions.setLogoutUser())
});

export default connect(null, mapDispatchToProps)(NewsAdminPreviewForm);
